<template>
  <section>
    <div id="pbbar"/>
    <div class="progress mb-3">
      <div
          class="progress-bar"
          role="progressbar"
          :style="progressStyle"
          :aria-valuenow="percentDone"
          aria-valuemin="0"
          aria-valuemax="100"
      ></div>
    </div>
    <p class="percent d-inline">{{ percentDone.toFixed() }} {{ $t('completed_percentage') }}</p>
  </section>
</template>
<script>
export default {
  name: 'progress-bar',
  props: {
    percentDone: {}
  },
  computed: {
    progressStyle() {
      let p = 0;
      if (this.percentDone > 100) p = 100;
      else p = this.percentDone;

      return "width: " + p + "%;";
    },
  }
}
</script>

<style>
.progress-bar {
  background-color: var(--btn-color);
}
</style>
